export const getBySlug = () =>
  groq`*[_type == 'resources' && slug.current == $slug][0]{..., "fileUrl": file.asset->url}`

export const getAll = () => groq`*[_type == 'resources']`
